// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth"; //firebase authentication
// import { getFirestore } from "firebase/firestore" //firestore database
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries






// https://firebase.google.com/docs/web/setup#available-libraries

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAg-cyYE2WX6DR1Cb9BW6exxXAbAHX6TgM",
  authDomain: "jcoteckvtu.firebaseapp.com",
  projectId: "jcoteckvtu",
  storageBucket: "jcoteckvtu.appspot.com",
  messagingSenderId: "551563598751",
  appId: "1:551563598751:web:7975f8c05d5bc13c1c7baa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize Firebase Storage

// Export Firebase services
export { app, auth, db, storage };






// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyAg-cyYE2WX6DR1Cb9BW6exxXAbAHX6TgM",
//   authDomain: "jcoteckvtu.firebaseapp.com",
//   projectId: "jcoteckvtu",
//   storageBucket: "jcoteckvtu.appspot.com",
//   messagingSenderId: "551563598751",
//   appId: "1:551563598751:web:7975f8c05d5bc13c1c7baa"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app)

// export { app, auth, db };




